// src/config/nftTemplates.js

const NFT_TEMPLATES = [
    {
      template_id: 890182, //mainnet: 890182 // testnet: 660020
      nft_name: 'Goose Coop',
      type: 'Ranch',
      rarity: 'Basic',
      img: require('../assets/nft/goose-coop.webp'),
      consumed: { first: 5, second: 3 },
      max_durability: 100,
      mints: ['350.0000 RANCH', '55.0000 TOOL'],
      mint_consume: 50,
      rewards: ['1.7000 RANCH'],
      charged_time: 3600
    },
    {
      template_id: 890183, //mainnet: 890183 // testnet: 660021
      nft_name: 'Chicken Coop',
      type: 'Ranch',
      rarity: 'Common',
      img: require('../assets/nft/chicken-coop.webp'),
      consumed: { first: 10, second: 5 },
      max_durability: 100,
      mints: ['2400.0000 RANCH', '400.0000 TOOL'],
      mint_consume: 100,
      rewards: ['5.0000 RANCH'],
      charged_time: 3600
    },
    {
      template_id: 890184, //mainnet: 890184 // testnet: 660022
      nft_name: 'Stable',
      type: 'Ranch',
      rarity: 'Uncommon',
      img: require('../assets/nft/stable.webp'),
      consumed: { first: 30, second: 15 },
      max_durability: 300,
      mints: ['7200.0000 RANCH', '1200.0000 TOOL'],
      mint_consume: 200,
      rewards: ['17.0000 RANCH'],
      charged_time: 3600
    },
    {
      template_id: 890185, //mainnet: 890185 // testnet: 660023
      nft_name: 'Barn',
      type: 'Ranch',
      rarity: 'Rare',
      img: require('../assets/nft/barn.webp'),
      consumed: { first: 60, second: 45 },
      max_durability: 900,
      mints: ['21600.0000 RANCH', '3600.0000 TOOL'],
      mint_consume: 300,
      rewards: ['54.0000 RANCH'],
      charged_time: 3600
    },
    {
      template_id: 890186, //mainnet: 890186 // testnet: 660024
      nft_name: 'Sickle',
      type: 'Farm',
      rarity: 'Common',
      img: require('../assets/nft/sickle.webp'),
      consumed: { first: 0, second: 5 },
      max_durability: 250,
      mints: ['1200.0000 RANCH', '200.0000 TOOL'],
      mint_consume: 100,
      rewards: ['5.0000 FARM'],
      charged_time: 3600
    },
    {
      template_id: 890187, //mainnet: 890187 // testnet: 660025
      nft_name: 'Scythe',
      type: 'Farm',
      rarity: 'Uncommon',
      img: require('../assets/nft/scythe.webp'),
      consumed: { first: 0, second: 20 },
      max_durability: 1000,
      mints: ['4800.0000 RANCH', '800.0000 TOOL'],
      mint_consume: 200,
      rewards: ['20.0000 FARM'],
      charged_time: 3600
    },
    {
      template_id: 890188, //mainnet: 890188 // testnet: 660026
      nft_name: 'Harvester',
      type: 'Farm',
      rarity: 'Rare',
      img: require('../assets/nft/harvester.webp'),
      consumed: { first: 0, second: 32 },
      max_durability: 1600,
      mints: ['19200.0000 RANCH', '3200.0000 TOOL'],
      mint_consume: 300,
      rewards: ['80.0000 FARM'],
      charged_time: 3600
    },
    {
      // template_id: 890189, //mainnet: 890189 // testnet: 660027
      template_id: 890189,
      nft_name: 'Workshop',
      type: 'Tool',
      rarity: 'Common',
      img: require('../assets/nft/workshop.webp'),
      consumed: { first: 133, second: 5 },
      max_durability: 250,
      mints: ['24000.0000 RANCH', '4000.0000 TOOL'],
      mint_consume: 400,
      rewards: ['100.0000 TOOL'],
      charged_time: 7200
    },
    {
      template_id: 901076, //mainnet: 901076 // testnet: 661554
      nft_name: 'Bronze Healer',
      type: 'healer',
      rarity: 'Bronze',
      img: require('../assets/nft/healer_bronze.webp'),
      heal_amount: 25,
      icon: require('../assets/nft/healer_icon.png'),
      border: '#cd7f32'
    },
    {
      template_id: 901081, //mainnet: 901081 // testnet: 661540
      nft_name: 'Silver Healer',
      type: 'healer',
      rarity: 'Silver',
      img: require('../assets/nft/healer_silver.webp'),
      heal_amount: 50,
      icon: require('../assets/nft/healer_icon.png'),
      border: '#c0c0c0'
    },
    {
      template_id: 901082, //mainnet: 901082 // testnet: 661555
      nft_name: 'Gold Healer',
      type: 'healer',
      rarity: 'Gold',
      img: require('../assets/nft/healer_gold.webp'),
      heal_amount: 75,
      icon: require('../assets/nft/healer_icon.png'),
      border: '#ffd700'
    },
    {
      template_id: 901083, // mainnet: 901083 // testnet: 661542
      nft_name: 'Diamond Healer',
      type: 'healer',
      rarity: 'Diamond',
      img: require('../assets/nft/healer_diamond.webp'),
      heal_amount: 100,
      icon: require('../assets/nft/healer_icon.png'),
      border: '#000000ff'
    }
  ];

  
  
  
  export default NFT_TEMPLATES;
  